<main id="main" class="main">
  <!-- Contenido del main aquí -->
  <div class="pagetitle">
    <router-outlet></router-outlet>
  </div>
</main>
